<template>
  <v-card
    :style="`margin:20px;padding:10px;background-image: linear-gradient(to bottom right, #fff, ${item.done ? 'gray' : item.numDeps > 0 ? 'red' : item.paused? 'orange' : 'green'});`"
    elevation="4"
  >
    <div
      style="display:flex; padding:0px; position:relative; top: -5px;"
      draggable
      :style="dropZoneStyle()"
      v-on:dragstart="dragStart($event)"
      v-on:dragover="dragOver($event)"
      v-on:dragleave="dragLeave($event)"
      v-on:dragend="dragEnd($event)"
      v-on:drop="drop($event)"
    >
      <v-badge
        :color="item.numDeps > 0 ? 'pink' : item.paused? 'orange' : 'green'"
        :content="item.numDeps"
      ></v-badge>
      <!-- <div>cumdeps {{item.cumDepentants ||0}}</div> -->
      <v-icon
        v-if="!isForeground"
        v-model="item.move"
        style="cursor: row-resize"
        title="drag"
      >mdi-drag</v-icon>
      <v-badge color="grey" :content="item.cumDepentants"></v-badge>

      <!-- <v-text v-model="item.numDeps">{{ item.numDeps}}</v-text> -->
      <v-text-field
        v-if="!item.done"
        v-model="item.title"
        v-on:keydown="keydownItem($event)"
        label="Title"
        :errorMessages="
          (item.title !== item.orig.title && ['uncommitted']) || []
        "
        required
      ></v-text-field>
      <div v-if="item.done" style="text-decoration:line-through; width: 100%">{{ item.title }}</div>
      <v-btn
        v-on:click="$emit('focusOnTask', item)"
        class="mx-2"
        fab
        dark
        x-small
        color="yellow"
        title="highlight in diagram"
      >
        <v-icon>mdi-file-tree</v-icon>
      </v-btn>
      <v-btn
        v-on:click="deleteTask"
        class="mx-2"
        fab
        dark
        x-small
        color="deep-orange"
        title="delete task"
      >
        <v-icon>mdi-delete-empty</v-icon>
      </v-btn>
      <v-btn
        @click="isEditing = !isEditing"
        class="mx-2"
        fab
        dark
        x-small
        color="brown"
        title="expand"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
      <v-btn
        v-if="!isForeground"
        v-on:click="expand"
        class="mx-2"
        fab
        dark
        x-small
        color="blue"
        title="expand"
      >
        <v-icon>mdi-arrow-expand-all</v-icon>
      </v-btn>
      <v-btn
        v-on:click="toggleDone"
        class="mx-2"
        fab
        dark
        x-small
        :color="item.done ? 'grey' : 'brown'"
        title="set/unset done"
      >
        <v-icon v-if="!item.done">mdi-checkbox-blank-circle-outline</v-icon>
        <v-icon v-if="item.done">mdi-checkbox-marked-circle-outline</v-icon>
      </v-btn>
      <v-btn
        v-on:click="togglePaused"
        class="mx-2"
        fab
        dark
        x-small
        :color="item.paused? 'orange' : 'green'"
        title="pause/unpause this task"
      >
        <v-icon v-if="!item.paused">mdi-timer-off-outline</v-icon>
        <v-icon v-if="item.paused">mdi-timer-outline</v-icon>
      </v-btn>
      <v-btn fab v-on:click="$emit('helptask')" x-small title="helpTop">
        <v-icon color="gray">mdi-help</v-icon>
      </v-btn>
    </div>
    <v-card v-if="!listMode" elevation="9" style="margin: 15px; display:flex">
      <v-card style="width:50%">
        <v-card-title>is required for:</v-card-title>
        <v-card-subtitle>
          <TaskPicker :searcher="searcher" @taskSelected="taskSelectedRequired"></TaskPicker>
        </v-card-subtitle>
        <v-list>
          <v-list-item v-for="dep in requiredForTasks" :key="dep.id">
            <v-list-item-content>
              <v-list-item-subtitle>
                <div style="display:flex;">
                  <v-icon
                    style="cursor:pointer;"
                    v-on:click="unlinkReq(dep.id)"
                    title="unlink"
                  >mdi-link</v-icon>
                  <div
                    style="cursor:pointer; text-decoration:underline; color: blue; display:inline; white-space: break-spaces;"
                    @click="expandDep(dep)"
                  >{{ dep.title }}</div>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
      <v-card style="width:50%">
        <v-card-title>depends On:</v-card-title>
        <v-card-subtitle>
          <TaskPicker :searcher="searcher" @taskSelected="taskSelectedDepends"></TaskPicker>
        </v-card-subtitle>
        <v-list>
          <v-list-item v-for="dep in item.dependsOn" :key="dep.id">
            <v-list-item-content>
              <v-list-item-subtitle>
                <div style="display:flex;">
                  <v-icon
                    style="cursor:pointer;"
                    v-on:click="unlink(dep.id)"
                    title="unlink"
                  >mdi-link</v-icon>
                  <div
                    style="cursor:pointer; text-decoration:underline; color: blue;white-space: break-spaces;"
                    @click="expandDep(dep)"
                  >{{ dep.title }}</div>
                </div>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card>
    </v-card>
    <div>
      <Editor
        v-if="isEditing"
        :value="item.description"
        @input="saveItem"
        @close="isEditing = false"
      />
      <div v-if="!isEditing" v-html="item.description"></div>
    </div>
  </v-card>
</template>

<script>
import sleep from "./sleep";
import TaskPicker from "./TaskPicker";
import Editor from "./Editor";
import * as api from "./api";

export default {
  name: "Task",
  components: {
    TaskPicker,
    Editor,
  },
  props: {
    currentBoardId: String,
    item: Object,
    tasks: Array,
    listMode: Boolean,
    isForeground: Boolean,
    searcher: Object,
  },
  data: () => ({
    isEditing: false,
    dragged: false,
    draggingOver: false,
    newTask: { id: "", title: "", description: "" },
  }),
  computed: {
    requiredForTasks: function () {
      return this.tasks.filter((t) => {
        return t.dependsOn.find((d) => d.id === this.item.id);
      });
    },
  },
  methods: {
    dropZoneStyle() {
      return this.draggingOver === this.item
        ? "background-color:yellow"
        : this.dragged === this.item
        ? "background-color:orange"
        : "";
    },
    async taskSelectedDepends(item) {
      if (item.id) {
        await api.link(this.item.id, item.id);
        this.$emit("taskChanged");
      }
    },
    async taskSelectedRequired(item) {
      if (item.id) {
        await api.link(item.id, this.item.id);
        this.$emit("taskChanged");
      }
    },
    async drop(e) {
      console.log(e, this.dragged, this.draggingOver, this.item);
      this.draggingOver = false;
      this.dragged = false;
      const draggedTaskId = e.dataTransfer.getData("text/plain");
      console.log({ draggedTaskId, item: this.item });
      e.preventDefault();
      if (this.item.id !== draggedTaskId) {
        await api.link(this.item.id, draggedTaskId);
      }
      this.$emit("taskChanged");
    },
    async unlink(depId) {
      await api.unlink(this.item.id, depId);
      this.$emit("taskChanged");
    },
    async unlinkReq(depId) {
      await api.unlink(depId, this.item.id);
      this.$emit("taskChanged");
    },
    async dragEnd() {
      this.dragged = false;
    },
    async dragStart(e) {
      this.dragged = this.item;
      e.dataTransfer.setData("text/plain", this.item.id);
    },
    async dragOver(e) {
      e.preventDefault();
      this.draggingOver = this.item;
    },
    async dragLeave(e) {
      e.preventDefault();
      this.draggingOver = false;
    },
    async toggleDone() {
      // this.item.done = !this.item.done;
      await api.updateTask({ ...this.item, done: !this.item.done });
      await sleep(500);
      this.$emit("taskChanged", this.item);
    },
    async togglePaused() {
      // this.item.done = !this.item.done;
      await api.updateTask({ ...this.item, paused: !this.item.paused });
      await sleep(500);
      this.$emit("taskChanged", this.item);
    },
    async saveItem(description) {
      await api.updateTask({ ...this.item, description });
      this.$emit("taskChanged", this.item);
      this.isEditing = false;
    },
    async keydownItem(e) {
      console.log(e, this.item);
      if (e.key === "Enter") {
        await api.updateTask({ ...this.item });
        this.$emit("taskChanged", this.item);
      }
    },
    async deleteTask() {
      await api.deleteTask(this.item.id);
      this.$emit("taskChanged", this.item);
    },
    async expand() {
      this.isEditing = false;
      this.$emit("setForegroundTask", this.item);
    },
    async expandDep(item) {
      this.isEditing = false;
      this.$emit("setForegroundTask", item);
    },
  },
};
</script>
